import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCheckWarrantBalToGLFields = {
  matchAmtFlag: '',
  date: '',
  warAmt: '',
  gLBalance: '',
};

export const checkWarrantBalanceToGL = {
  namespaced: true,
  actions: {
    async warrantBalToGLGatherInformation({ commit, dispatch }, { criteria }) {
      let results;
      const gqlfields = defaultCheckWarrantBalToGLFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query
                    warrantBalToGLGatherInformation ($criteria:warrantBalToGLGatherInfoCriteriaType!) {
                    warrantBalToGLGatherInformation(criteria: $criteria){
                    ${fieldsToGqlString(gqlfields)}
                    },
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.warrantBalToGLGatherInformation || {}) : {};
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting gather information.', { root: true });
      }
      return null;
    },
  },
};
export default checkWarrantBalanceToGL;
